import { mapActions } from 'vuex'

export default {
  ...mapActions(['logout', 'setupJWT', 'updateUserData', 'setupUser']),
  afterLogin ({token, user}) {
    return Promise.all([
      this.updateUserData(user),
      this.setupJWT(token)
    ])
  },

  doLogout () {
    const currentUser = { ...this.user }
    const isProfessional = (user) => {
      return user.type === 'professional'
    }

    const isCompany = (user) => {
      return user.type === 'company'
    }

    this.logout()
      .then(() => {
        if (isProfessional(currentUser)) {
          return this.$router.push({name: 'auth.professional.login'})
        }

        if (isCompany(currentUser)) {
          return this.$router.push({name: 'auth.company.login'})
        }

        window.location.href = '/'
      })
  },
  onUploadedAvatar (uploaded, data) {
    if (!uploaded) {
      return
    }
    this.showUpload = false
    const user = {...data}
    user.avatar = user.avatar + '?' + new Date()
    this.updateUserData(user)
  },
  changeTenant (tenant) {
    this.$http.put('v1/employee/tenants/change/' + tenant.id)
      .then(({data}) => {
        this.$toast.success('Empresa alterada com sucesso para: ' + data.user.name)
        this.user.type = 'professional'
        this.user.last_tenant_id = tenant.id
        this.updateUserData(this.user)
          .then(() => {
            this.$router.push({name: 'professional.dashboard.professional.index'})
          })

        // this.afterLogin(data)
        //   .then(() => {
        //     this.setupUser()
        //       .then(() => {
        //         return this.$router.push({name: 'dashboard'})
        //       })
        //   })
      })
  },
  // Direcionando para dashboard como pacienta partindo do professional
  professionalToPatient () {
    this.toPatient = true
    this.$router.push({name: 'patient.dashboard.index'})
  }
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/user/resources/methods.js